const pl = {// 波兰语Polish
    message: {
        noNet: 'Błąd sieci',
        goCopilot: 'Analiza snu tej nocy i sugestie',
        goCopilotWeek: 'Analizuj sen z tego tygodnia',
        goCopilotMonth: 'Analizuj sen w tym miesiącu',
        updateAppTips: 'Aktualna wersja nie może być wyświetlona. Proszę zaktualizować do najnowszej wersji!',
        vip: {
            openVip: "Odblokuj członkostwo",
            sleepVip: "Członkostwo w Śnie",
            notOpened: "Brak subskrypcji",
            expired: "Wygasła",
            validUntil: "Wygasa: ",
            unlockAll: "Odblokuj całą muzykę wspomagającą sen",
            trendAnalysis: "Analiza tendencji dot. snu",
            reportAnalysis: "Spersonalizowane miesięczne raporty analiz",
            deepAnalysis: "Analiza głębokiego snu",
            monthlyVip: "Miesięcznie",
            quarterlyVip: "Kwartalnie",
            annualVip: "Rocznie",
            priceEvery: "{yuan}{price} na miesiąc",
            yuanEveryMonth: "",
            yuanEveryQuarter: "",
            yuanEveryYear: "",
            open: "Odblokuj",
            renew: "Odnów teraz",
            renewal: "Odnowienie",
            vipMonthExtention: "",
            vipQuartyExtention: "",
            vipYearExtention: "",
            discountLimited: "Specjalna oferta - {discount} taniej",
            discountDuration: "Oferta ograniczona czasowo do {date}",
            vipUseDescription1: 'Odblokuj całą muzykę wspomagającą sen',
            vipUseDescription2: 'Trendy dotyczące pory snu i budzenia',
            vipUseDescription3: 'Trendy dotyczące tętna i poziomu tlenu we krwi',
        },
        sleep: {
            regularSleep: "Regularny sen",
            nap: "Drzemka",
            hour: "godz.",
            minute: "min",
            sleepQuality: "Jakość snu",
            sober: "Obudzony",
            fastEye: "REM",
            lightSleep: "Sen lekki",
            darkSleep: "Sen głęboki",
            sleepStage: "Fazy snu",
            suggestRange: "Zalecenie",
            avgSleepHeartRate: "Śr. tętno podczas snu",
            timesEveryMin: "bpm",
            unitsleepbreath: "brpm",
            once: "bpm",
            sleepOxygen: "Tlen we krwi podczas snu",
            sleepBreath: "Częstość oddechów podczas snu",
            highest: "Maks.",
            lowest: "Min.",
            maximum: "Maks.",
            minimum: "Min.",
            normal: "Normalny",
            average: "Śr.",
            openMonitoring:  "Liczba razy monitorowania snu",
            longerMonitor: "Więcej dni monitorowania pozwoli otrzymać bardziej precyzyjne dane",
            avgStatistics: "Uśrednione dane",
            sleepDuration: "Czas trwania snu",
            bedTime: "Pora snu",
            getUpTime: "Godzina pobudki",
            maxSleep: "Najdłuższy czas trwania snu",
            minSleep: "Najkrótszy czas trwania snu",
            earliestBedTime: "Najwcześniejsza pora snu",
            latestBedTime: "Najpóźniejsza pora snu",
            earliestGetUpTime: "Najwcześniejsza godzina pobudki",
            latestGetUpTime: "Ostatnia godzina pobudki",
            excellent: "Wyśmienicie",
            good: "Dobrze",
            improvement: "Należy poprawić",
            importance: "Wymaga uwagi",
            sleepEnough: "Wystarczająco: {min}-{max}h",
            sleepToLong: "Za długo: dłużej niż {hour}h",
            sleepDebt: "Niewystarczająco: krócej niż {hour}h",
            sleepPeriodVary1: "Fazy snu różnią się w zależności od wieku. Podany przez ciebie wiek to {age}",
            sleepPeriodVary2: "Fazy snu różnią się w zależności od wieku. Podany przez ciebie wiek to {month} mies.",
            toSet: "Ustawienia",
            openVipToSee: "Ulepsz członkostwo, aby kontynuować",
            short_mon: "Pon",
            short_tue: "Wt",
            short_wed: "Śr",
            short_thu: "Czw",
            short_fri: "Pt",
            short_sat: "Sob",
            short_sun: "Niedz",
            mon: "Pon",
            tue: "Wt",
            wed: "Śr",
            thu: "Czw",
            fri: "Pt",
            sat: "Sob",
            sun: "Niedz",
            monday: "Pon",
            tuesday: "Wt",
            wednesday: "Śr",
            thursday: "Czw",
            friday: "Pt",
            saturday: "Sob",
            sunday: "Niedz",
            day: "",
            heartRate: "Tętno",
            bloodOxygen: "Tlen we krwi",
            breathRate: "Częstość oddechów",
            noData: "Brak zapisów o regularnym śnie",
            noNapData: "Brak zapisów o drzemkach",

            sleepLateTipCommonStart: "Poszedłeś do łóżka później niż planowana pora snu ostatniej nocy.",
            sleepTipCommonEnd: "Regularny sen to zdrowy sen.",
            sleepLate3tip: "W tym tygodniu chodzisz spać później niż zazwyczaj. To już {day} dzień z rzędu. Zwróć uwagę na sen, bez względu na swój rozkład dnia. ",
            sleepLate2TipStart: "Poszedłeś do łóżka później niż planowana pora snu ostatniej nocy.",
            sleepLate2Tip: "W tym tygodniu chodzisz spać później niż zazwyczaj. To już drugi dzień z rzędu. Upewnij się, że śpisz odpowiednią ilość czasu.",
            getUpEarlyTip: "Dzisiejsza godzina pobudki wypadła wcześniej, niż zaplanowana. Regularny sen to zdrowy sen.",
            getUpLateTip: "Wstałeś później niż zaplanowana godzina pobudki dzisiaj.",
            sleepEarlyTip: "Wczoraj wieczorem poszedłeś/aś spać wcześniej niż przewidywał to czas snu.",



            demoData: "Dane demo",


            sleepCompare: "Porównanie danych snu",
            seeMore: "Więcej",
            sleepQualityData: "Jakość Twojego snu: {value}; ",
            sleepQualityCompare1: "to więcej niż w przypadku ",
            sleepQualityCompare2: "Proporcja wysokiej wartości",
            sleepQualityCompare3: " procent użytkowników.",
            sleepQualityBestTip: "Dobry sen zapewnia zdrowy sen～",
            sleepQualityGoodTip: "Jakość snu wymaga poprawy!",
            sleepQualityBadTip: "Uważaj i śpij dobrze",
            sleepTimeText: "Czas trwania snu",
            avgCnSleepTimeText: "中国平均睡眠时长",
            avgGlobalSleepTime: "Globalny średni czas snu",
            sleepTimeTip: "Każdy powinien zapewnić sobie wystarczającą ilość snu, aby skutecznie wyeliminować zmęczenie i cieszyć się zdrowiem. Nie śpij jednak zbyt długo.",
            bedTimeText: "Pora snu",
            avgCnBedTimeText: "中国平均就寝时间",
            avgGlobalBedTime: "Globalna średnia pora snu",
            bedTimeTip: "Pora snu może wydawać się czymś oczywistym, jest to jednak kluczowy wskaźnik. Prawidłowa rutyna związana z tą porą chroni mózg, ułatwia zasypianie i poprawia jakość snu.",
            getUpTimeText: "Godzina pobudki",
            avgCnGetUpTimeText: "中国平均起床时间",
            avgGlobalGetUpTime: "Globalna średnia pora budzenia",
            getUpTimeTip: "Pora budzenia również jest wskaźnikiem, którego nie można zaniedbywać. Regularny czas wstawania zapewnia dobry stan psychiczny przez cały dzień.",

            sleepStageTitle: "Analiza etapów snu",
            avgAwakeSleep: "Średn. czas bycia obudzonym",
            avgFastEyeMove: "Średn. czas REM",
            avgShallowSleep: "Średn. czas lekkiego snu",
            avgDeepSleep: "Średn. czas głębokiego snu",

            skinTemperature: "Temperatura skóry",
            temperatureLow: "Proporcja niskiej wartości",
            temperatureHigh: "Proporcja wysokiej wartości",
            reasonableRange: "Rozsądny zakres",

            compare: {
                dataInsights: 'Analiza danych',
                today: 'Dzisiaj',
                yesterday: 'Wczoraj',
                currentWeek: 'Ta tydzień',
                preWeek: 'W zeszłym tygodniu',
                currentMonth: 'Ten miesiąc',
                preMonth: 'Poprzedni miesiąc',
                daySleepTimeHigher: 'Dzisiejsza długość snu jest dłuższa niż wczorajsza.',
                daySleepTimerLower: 'Dzisiejsza długość snu jest krótsza niż wczorajsza.',
                daySleepTimerRegular: 'Długość snu w ciągu ostatnich dwóch dni jest dość regularna.',

                dayBedTimeEarly: 'Czas snu dzisiaj jest wcześniejszy niż wczoraj.',
                dayBedTimeLater: 'Czas snu dzisiaj jest późniejszy niż wczoraj.',
                dayBedTimeRegular: 'Ostatnio sen był dość regularny przez ostatnie dwa dni.',

                dayGetupTimeEarly: ' Dzisiejszy czas wstawania był wcześniej niż wczoraj.',
                dayGetupTimeLater: 'Dzisiejszy czas wstawania był później niż wczoraj.',
                dayGetupTimeRegular: 'W ciągu ostatnich dwóch dni czas wstawania był dość regularny.',
                DayEmptyTip: 'Nie ma rejestrów snu z wczoraj. Kontynuowanie noszenia urządzenia podczas snu pozwoli na zrozumienie danych snu.',


                weekSleepTimeHigher: 'Średni czas snu w tym tygodniu jest dłuższy niż w zeszłym tygodniu.',
                weekSleepTimerLower: 'Średni czas snu w tym tygodniu jest krótszy niż w zeszłym tygodniu.',
                weekSleepTimerRegular: 'Średni czas snu w ciągu ostatnich dwóch tygodni jest dość stabilny.',

                weekBedTimeEarly: 'Średni czas snu w tym tygodniu jest wcześniejszy niż w zeszłym tygodniu.',
                weekBedTimeLater: 'Średni czas snu w tym tygodniu jest późniejszy niż w zeszłym tygodniu.',
                weekBedTimeRegular: 'Średni czas snu w ciągu ostatnich dwóch tygodni jest dość stabilny.',

                weekGetupTimeEarly: 'Średni czas wstawania w tym tygodniu jest wcześniejszy niż w zeszłym tygodniu.',
                weekGetupTimeLater: 'Średni czas wstawania w tym tygodniu jest późniejszy niż w zeszłym tygodniu.',
                weekGetupTimeRegular: 'Średni czas wstawania w ciągu ostatnich dwóch tygodni był dość regularny.',
                weekEmptyTip: 'W ubiegłym tygodniu nie było danych na temat snu, ale noszenie urządzenia podczas snu może pomóc zrozumieć dane dotyczące snu.',


                monthSleepTimeHigher: 'Średni czas snu w tym miesiącu jest dłuższy niż w poprzednim miesiącu.',
                monthSleepTimerLower: 'Średni czas snu w tym miesiącu jest krótszy niż w poprzednim miesiącu.',
                monthSleepTimerRegular: 'Średni czas snu w ciągu ostatnich dwóch miesięcy jest dość regularny.',

                monthBedTimeEarly: 'Średni czas zaśnięcia w tym miesiącu jest wcześniejszy niż w poprzednim miesiącu.',
                monthBedTimeLater: 'Średni czas zaśnięcia w tym miesiącu jest późniejszy niż w poprzednim miesiącu.',
                monthBedTimeRegular: 'Średni czas usypiania w ciągu ostatnich dwóch miesięcy jest dość regularny.',

                monthGetupTimeEarly: 'Średni czas budzenia się w tym miesiącu jest wcześniejszy niż w poprzednim miesiącu.',
                monthGetupTimeLater: 'Średni czas budzenia się w tym miesiącu jest późniejszy niż w poprzednim miesiącu.',
                monthGetupTimeRegular: 'Średni czas budzenia się w ciągu ostatnich dwóch miesięcy jest dość regularny.',
                monthEmptyTip: 'W zeszłym miesiącu nie rejestrowano danych snu. Regularne noszenie urządzenia do monitorowania snu pomaga zrozumieć informacje na temat danych dotyczących snu.',

                delete: 'Usunąć',
                deleteTitle: 'Usunąć codzienną rejestrację raportów?',
                deleteContent: 'Po usunięciu rejestracji dziennych zostaną również usunięte odpowiadające im rejestracje tygodniowe i miesięczne. Czy na pewno chcesz trwale usunąć dzisiejsze rejestracje dziennych raportów?',
                confirm: 'Potwierdzić',
                cancel: 'Anuluj'

            }
        },
        advert: {
            tip: 'Early birds DISCOUNT',
            ActivityStartTime: 'Godzina rozpoczęcia',
            ActivityEndTime: 'Godzina zakończenia',
            ActivityEnded: '已结束～',
            buy: 'Purchase now',
            explainTitle: 'Activity description:',
            explainDesc1: '1. The special offer for early birds is from December 16th, 2022 to December 31st, 2022.',
            explainDesc2: '2. During the activity, you can purchase the member rights with a discount of 65%.',
            explainDesc3: '3. After you recharge successfully, you can check the validity period of your membership in “Home-Sleep Card-Start to Sleep-vip”',
            explainDescLast: '4. mobvoi has the right of the final interpretation of this activity.',
            viewVipFunctions: 'Check functions of membership.',
            VipFunctionsExplain: "Functions of membership"
        },
        snore: {
            "snoringDetectionReport": "Raport wykrywania chrapania",
            "snoreRecord": "Rejestr chrapania",
            "more": "Zobacz więcej",
            "notOpenedTip": "Przed pójściem spać, proszę włączyć funkcję monitorowania chrapania w karcie \"Dom-Sen-Rozpocznij sen-Spal teraz\". Pamiętaj, aby wyłączyć monitorowanie po śnie, a zostanie automatycznie wygenerowany zapis chrapania.",
            "noSnoring": "Brak chrapania podczas tej snu~",
            "snoreData": "Dane dźwięku chrapania",
            "snoreReport": "Raport o chrapaniu",
            "snoreDuration": "Czas trwania",
            "avgSnoreDb": "Średni poziom decybeli",
            "maxSnoreDb": "Maksymalny poziom decybeli",
            "minSnoreDb": "Minimalny poziom decybeli",
            "snoreDbRatio": "Stosunek decybeli chrapania",
            "snoreWaveforms": "Trend fali chrapania",
            "snoreFrequency": "Rozkład częstotliwości chrapania",
            "snoreFrequencyTrend": "Tendencja częstotliwości chrapania",
            "low": "Niska częstotliwość",
            "medium": "Średnia częstotliwość",
            "high": "Wysoka częstotliwość",
            "softSnore": "Miękki podniebienie chrapanie",
            "uvulaSnore": "Chrapanie języczkowe",
            "tongueSnore": "Chrapanie podstawy języka",
            "snoreRecordSetting": "Ustawienia",
            "storageMethods": "Metoda zapisu",
            "storageDurations": "Czas zapisu",
            "local": "Lokalny",
            "cloud": "Chmura",
            "localStorage": "Lokalne przechowywanie",
            "cloudStorage": "Przechowywanie w chmurze",
            "storageWayTips": "Możesz wybrać, czy chcesz przechowywać dane o chrapaniu lokalnie czy w chmurze. Przechowywanie lokalne zajmuje miejsce na dysku, a aby przechowywać w chmurze, należy posiadać członkostwo sleep membership, co umożliwia przechowywanie danych przez maksymalnie 180 dni.",
            "storagePeriod": "Możesz wybrać czas przechowywania danych dotyczących chrapania. Dla ochrony bezpieczeństwa danych ustaliliśmy minimalny okres przechowywania wynoszący 1 dzień i maksymalny 180 dni. Jeżeli wybierzesz 1 dzień, dane o chrapaniu zostaną usunięte następnego dnia. Członkowie mogą korzystać z okresów przechowywania wynoszących 30 i 180 dni po zapisaniu się.",
            "storagePeriodWearCopilot": "Możesz wybrać czas przechowywania danych dotyczących chrapania.",
            "day": "Dzień",
            "days": "Dni",
            recordSnoreTitle1: '1.Rejestrowanie dźwięków chrapania',
            recordSnoreContent1: 'Przed snem włącz funkcję wykrywania chrapania i pamiętaj, aby ręcznie zakończyć sen, aby zarejestrować pełne dane o chrapaniu.',
            recordSnoreTitle2: '2.Sprawdź rejestr chrapania w raporcie dziennym',
            recordSnoreContent2: 'W dziennym raporcie można zobaczyć 3 rejestracje chrapania. Kliknij na nie, aby odtworzyć swoje rejestracje chrapania.',
            recordSnoreTitle3: '3.Dalsza analiza danych z chrapaniem',
            recordSnoreContent3: 'W codziennym raporcie kliknij "Więcej", aby zobaczyć wszystkie zapisy chrapania i przeanalizować poziom głośności, fale, dystrybucję, częstotliwość itp.',
            "tips": "Podpowiedź",
            "vipTips": "Aby aktywować tę funkcję, trzeba subskrybować członkostwo w snie. Czy chciałbyś teraz subskrybować członkostwo w snie?",
            "open": "Aktywuj teraz",
            "noAudioTip": "Ładowanie dźwięku chrapania, proszę czekać.",
        },
    },
}

export default pl
